// Provide services for Product Brand
const ProductBrandService = {
  /**
   * Build payload for Classification payload
   *
   * @param {classification} string - classifications comme-separated String of payload
   */
  prepClassification: (classification) => {
    const classificationPayload = []

    if (typeof classification === 'string' && classification !== ''){
      const classifications = classification.split(',')

      classifications.forEach((classification) => {
        classificationPayload.push(classification)
      })
    }
    else if (typeof classification === 'object') {
      classification.forEach((classification) => {
        classificationPayload.push(classification.id)
      })
    }

    return classificationPayload
  }
}

export default ProductBrandService
